import React from 'react'
import videojs, {VideoJsPlayer} from 'video.js'
import 'video.js/dist/video-js.css'

interface PlayerProps {
    movieUrl: string;
    posterUrl: string;
}

export default function Player({movieUrl, posterUrl}: PlayerProps) {
	const playerRef = React.useRef(null)

	const videoJsOptions = { // lookup the options in the docs for more options
		autoplay: true,
		controls: true,
		responsive: true,
		fluid: true,
		sources: [{
			src: movieUrl,
			type: 'application/x-mpegURL'
		}]
	}

	const handlePlayerReady = (player: any) => {
		playerRef.current = player

		// you can handle player events here
		player.on('waiting', () => {
			console.log('player is waiting')
		})

		player.on('dispose', () => {
			console.log('player will dispose')
		})
	}

	return (
		<>
			<VideoJS options={videoJsOptions} onReady={handlePlayerReady}/>
		</>
	)
}

export const VideoJS = (props: any) => {

	const videoRef = React.useRef(null)
	const playerRef = React.useRef<VideoJsPlayer | null>(null)
	const {options, onReady} = props

	React.useEffect(() => {
		// make sure Video.js player is only initialized once
		if (!playerRef.current) {
			const videoElement = videoRef.current
			if (!videoElement) return

			const player = playerRef.current = videojs(videoElement, options, () => {
				console.log('player is ready')
				onReady && onReady(player)
			})
		} else {
			// you can update player here [update player through props]
			// const player = playerRef.current;
			// player.autoplay(options.autoplay);
			// player.src(options.sources);
		}
	}, [options])

	// Dispose the Video.js player when the functional component unmounts
	React.useEffect(() => {
		return () => {
			if (playerRef.current) {
				playerRef.current.dispose()
				playerRef.current = null
			}
		}
	}, [])

	return (
		<div data-vjs-player>
			<video ref={videoRef} className="video-js vjs-big-play-centered"/>
		</div>
	)
}